// Browser-side download helper. Builds a Blob from a snippet string and
// triggers an <a download> click, then revokes the object URL. Kept
// dependency-free so it works the same in the integration cards and in
// any future per-event integration tab.

export function downloadSnippet(filename: string, contents: string): void {
  const blob = new Blob([contents], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
